export default function CTASection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20various%20premium%20lifestyle%20items%20including%20a%20leather%20bag%20perfume%20bottle%20metallic%20watch%20and%20designer%20belt%20arranged%20harmoniously%20on%20a%20warm%20terracotta%20surface%20with%20soft%20golden%20hour%20lighting%20creating%20long%20shadows%20editorial%20product%20photography%20cohesive%20aesthetic&width=1800&height=800&seq=cta-flatlay-bg-v03&orientation=landscape"
          alt="Przejdź do kaspreadsheet.com"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-32 flex flex-col items-start">
        <h2 className="font-heading font-bold text-5xl md:text-7xl text-white leading-none lowercase mb-4">
          gotowy na zakupy?
        </h2>

        <div className="flex flex-col md:flex-row items-start md:items-end justify-between w-full gap-8 mt-8">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-3 px-6 py-3.5 rounded-full bg-white text-foreground-950 font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
          >
            Przejdź do Kaspreadsheet.com
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-950 text-white group-hover:bg-accent-500 transition-colors">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>

          <p className="text-white/80 text-base md:text-lg max-w-md leading-relaxed text-right">
            Bezpieczne przekierowanie do oficjalnego katalogu. Pełna ochrona kupującego i zweryfikowane linki.
          </p>
        </div>
      </div>
    </section>
  );
}